document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');

  if (menuButton) {
    menuButton.addEventListener('click', () => {
      const isOpen = document.body.classList.toggle('menu-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });

    document.querySelectorAll('.sg-mobile-menu a').forEach((link) => {
      link.addEventListener('click', () => {
        document.body.classList.remove('menu-open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });
  }

  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const select = card.querySelector('[data-variant-select]');
    const price = card.querySelector('[data-card-price]');
    const comparePrice = card.querySelector('[data-card-compare]');
    const variantInput = card.querySelector('[data-variant-id]');
    const addButton = card.querySelector('[data-add-button]');

    if (!select) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      variantInput.value = option.value;

      if (price) price.textContent = option.dataset.price || '';

      if (comparePrice) {
        comparePrice.textContent = option.dataset.compare || '';
        comparePrice.hidden = !option.dataset.compare;
      }

      addButton.disabled = option.dataset.available !== 'true';
      addButton.textContent = option.dataset.available === 'true'
        ? addButton.dataset.availableText
        : addButton.dataset.soldText;
    });
  });
});
